import React from "react";



const DashboardTable  = ({data}) => {

   


  return (
    <div className="overflow-auto max-h-[80vh]  border border-gray-300 rounded-md">
      <table className="table-auto min-w-[1200px] w-full border-collapse text-sm bg-white">
        <thead className="bg-primary-400 text-nowrap">
          <tr className="sticky top-0 z-10 bg-primary-400 text-white ">
            <th className="border px-2 py-2">Sr. No</th>
            <th className="border px-2 py-2">Position Received Date</th>
            <th className="border px-2 py-2">Clarity Call Date</th>
            <th className="border px-2 py-2">Position Renew Date</th>
            <th className="border px-2 py-2">TAT to Selection</th>
            <th className="border px-2 py-2">Target Date of Selection</th>
            <th className="border px-2 py-2">Candidate Date of Selection</th>
            <th className="border px-2 py-2">Revised Target Date of Selection</th>
            <th className="border px-2 py-2">Actual TAT of Selection</th>
            <th className="border px-2 py-2">TAT Delay in Selection</th>
            <th className="border px-2 py-2">Reason of Delay</th>
            <th className="border px-2 py-2">Select to Offer TAT</th>
            <th className="border px-2 py-2">Approx Offer Date</th>
            <th className="border px-2 py-2">Actual Offer Date</th>
            <th className="border px-2 py-2">Official Notice Period</th>
            <th className="border px-2 py-2">Approx DOJ</th>
            <th className="border px-2 py-2">Actual DOJ</th>
            <th className="border px-2 py-2">Client</th>
            <th className="border px-2 py-2">HR Name/HM</th>
            <th className="border px-2 py-2">Position Name</th>
            <th className="border px-2 py-2">Number of Positions</th>
            <th className="border px-2 py-2">Current Active Role</th>
            <th className="border px-2 py-2">Closed</th>
            <th className="border px-2 py-2">Budget</th>
            <th className="border px-2 py-2">Billable CTC</th>
            <th className="border px-2 py-2">Commercial %</th>
            <th className="border px-2 py-2">Billing Amount per position</th>
            <th className="border px-2 py-2">Business Ensurity %</th>
            <th className="border px-2 py-2">Business Ensurity Revenue</th>
            <th className="border px-2 py-2">Status</th>
            <th className="border px-2 py-2">Current Delivery Update</th>
            <th className="border px-2 py-2">Payment Terms</th>
            <th className="border px-2 py-2">Approx Payment Receiving Date</th>
            <th className="border px-2 py-2">Internal SPOC</th>
            <th className="border px-2 py-2">Selected Candidate</th>
            <th className="border px-2 py-2">Recruiter Name</th>
          </tr>
        </thead>
        <tbody>
        {data.map((record, index) => (
            <tr key={index} className="hover:bg-gray-50 text-center text-exgray-500">
                <td className="border px-2 py-1">{record["Sr.No"]}</td>
                <td className="border px-2 py-1">{record["Position received date"]}</td>
                <td className="border px-2 py-1">{record["Clarity call date"]}</td>
                <td className="border px-2 py-1">{record["Position renew date"]}</td>

                <td className="border px-2 py-1">{record["TAT to selection as per SLA"]}</td>
                <td className="border px-2 py-1">{record["Target Date of Selection"]}</td>
                <td className="border px-2 py-1">{record["Candidate Date of selection"]}</td>
                <td className="border px-2 py-1">{record["Revised Target Date of Selection"]}</td>
                <td className="border px-2 py-1">{record["Actual TAT of selection"]}</td>
                <td className="border px-2 py-1">{record["TAT - Delay in selection"]}</td>


                <td className="border px-2 py-1 min-w-96">{record["Reason of delay/HOLD"]}</td>
                <td className="border px-2 py-1">{record["Select to offer TAT"]}</td>
                <td className="border px-2 py-1">{record["Approx Offer date"]}</td>
                <td className="border px-2 py-1">{record["Actual Offer date"]}</td>
                <td className="border px-2 py-1">{record["Official Notice Period"]}</td>
                <td className="border px-2 py-1">{record["Approx DOJ"]}</td>
                <td className="border px-2 py-1">{record["Actual DOJ candidate will join"]}</td>
                <td className="border px-2 py-1">{record["Client"]}</td>
                <td className="border px-2 py-1">{record["HR name/HM"]}</td>
                <td className="border px-2 py-1">{record["Position Name"]}</td>
                <td className="border px-2 py-1">{record["Number of Positions"]}</td>
                <td className="border px-2 py-1">{record["Current Active role"]}</td>
                <td className="border px-2 py-1">{record["closed"] ? "Yes" : "No"}</td>
                <td className="border px-2 py-1">{record["Budget"]}</td>
                <td className="border px-2 py-1">{record["Billable CTC"]}</td>
                <td className="border px-2 py-1">{record["Commercial %"]}</td>
                <td className="border px-2 py-1">{record["Billing amount per position"]}</td>
                <td className="border px-2 py-1">{record["Business Ensurity  (100/75/50/25) -%"]}</td>
                <td className="border px-2 py-1">{record["Business Ensurity (actual revenue)"]}</td>
                <td className="border px-2 py-1">{record["Status"]}</td>
                <td className="border px-2 py-1">{record["Current delivery update"]}</td>
                <td className="border px-2 py-1">{record["Payment terms ( in days)"]}</td>
                <td className="border px-2 py-1">{record["Approx Payment receiving date"]}</td>
                <td className="border px-2 py-1">{record["Internal SPOC"]}</td>
                <td className="border px-2 py-1">{record["Selected candidate name"]}</td>
                <td className="border px-2 py-1">{record["Recruiter name"]}</td>
            </tr>
        ))}
        </tbody>

      </table>
    </div>
  );
};

export default DashboardTable;
